import React, { Component } from 'react';
import Util from '../../lib/util.js';
import User from 'services/user2';
import { Msg } from 'react-weui';
import Public from 'public';

/**
 * 企业微信登录跳转页
 *
 * appid	      第三方应用id（即ww或wx开头的suite_id）。注意与企业的网页授权登录不同
 * redirect_uri	授权后重定向的回调链接地址，请使用urlencode对链接进行处理 ，注意域名需要设置为第三方应用的可信域名
 *
 */
class WorkWx extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
    };
    this.dialogMsg = '';
  }

  init() {
    let { code } = Util.getParamObj(window.location.search);
    Public.isWeWork = true;
    User.weWorkInit(code, null).then(response => {
      if (response.success) {
        this.props.history.push('/mp/index');
      } else {
        // this.setState({ errorMsg: response.errorMsg });
        this.props.history.push('/mp/login');
      }
    });
  }

  componentDidMount() {
    this.init();
  }

  render() {
    let errorMsg = this.state.errorMsg;
    if (errorMsg) {
      return <Msg type="warn" title={errorMsg} />;
    }
    return '';
  }
}

export default WorkWx;
